import type { SVGProps } from 'react';
const SvgSwitchLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#switch_left_svg__a)">
      <path
        fill="currentColor"
        d="M8.5 8.62v6.76L5.12 12 8.5 8.62ZM10 5l-7 7 7 7V5Zm4 0v14l7-7-7-7Z"
      />
    </g>
    <defs>
      <clipPath id="switch_left_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSwitchLeft;
